<template>
  <div class="car-details frosted-glass">
    <ModalView v-if="remoteLearnMore" @hide="remoteLearnMore = false">
      <RemoteLearnMore @hide="remoteLearnMore = false" />
    </ModalView>
    <ModalView v-else-if="showRemoteModal" @hide="hideRemoteModal()">
      <RemoteCommands
        :shown="sidebarVisible"
        :vehicle="currentCar.Vehicle"
        @hide="showRemoteModal = false" 
        @learn-more="remoteLearnMore = true"
      />
    </ModalView>
    <!-- <div style="height: 100%; margin-right: -20px"> -->
    <div class="detail-head flex">
      <div class="flex column">
        <span class="car-title">{{ currentCar["Vehicle Label"] }}</span>
        <span class="car-subtitle" v-if="$store.state.inDealerMode && currentCar['Stock']">
          {{ $t("message.stockNumber") }}: {{ currentCar["Stock"] }}
        </span>
        <span class="car-subtitle" v-if="$store.state.inDealerMode">
          {{ $t("message.vin") }}: {{ currentCar["VIN"] }}
        </span>
        <span class="car-last-seen">{{ $t("message.lastSeenOnToday") }}, 09:04:14 AM</span>
        <span class="car-last-seen" v-if="driver && driver['Name'] === 'Patrick Watson'">{{
          $t("message.fullAddress")
        }}</span>
        <span class="car-last-seen" v-else>{{
          $t("message.shortAddress")
        }}</span>
        <span class="car-update-location">Update Location</span>
      </div>
      <img class="exit" src="@/assets/clear.svg?external" @click="$emit('clearCurrentCar')" />
    </div>
    <div class="detail-body">
      <div class="img-wrap" v-if="currentCar.details.profileImage">
        <img
          class="jellybean"
          :class="{ clickable: canClickVehicle }"
          :src="require('@/assets/' + currentCar.details.profileImage)"
          @click="goToVehicleDetailPage"
        />
        <div class="outer-circle-btn" @click="showRemoteModal = true">
          <div class="inner-circle-btn">
            <img src="@/assets/settings_remote.svg?external" />
          </div>
        </div>
      </div>
      <div class="below-img">
        <TagsList :style="{
          // position: 'absolute',
          top: '100%',
          left: 0,
          display: 'flex',
        }" :tags="currentCar.Tags" iconOnly />
        <PRNDL current="D" />
      </div>
      <div class="stats-grid">
        <FuelGauge :class="{ 'fuel-gauge': $store.state.inDealerMode }" :value="currentCar.details.fuel"
          :miles="currentCar.details.range" :ev="currentCar.details.ev" small />
        <FuelGauge v-if="!this.$store.state.inDealerMode && currentCar.details.map[whichMap]" speed :value="currentCar.details.map[whichMap].speed" small />
        <div class="diagnostics flex center column">
          <div class="icons flex flex-wrap">
            <div v-if="currentCar.details.diagnostics.oil" class="icon airbag">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g fill="none" fill-rule="evenodd">
                  <path fill="var(--grey)"
                    d="M8.13 6.86v1.16h3.125l2.93 2.022 3.683-1.984.214-.054H21L14.252 15.5H3.968V6.98H2v-.86h2.852v1.9h2.393V6.86H5.88V6h3.616v.86H8.13zM4.851 8.88v5.76h9l5.199-5.776h-.855l-4.068 2.193-3.155-2.176H4.852zm11.895 6.164a7.695 7.695 0 0 0-.477.785c-.204.393-.312.722-.312.952 0 .757.581 1.359 1.285 1.359.702 0 1.282-.602 1.282-1.36h.442-.442c0-.229-.108-.559-.311-.951a7.696 7.696 0 0 0-.477-.785 12.21 12.21 0 0 0-.495-.67c-.17.214-.337.44-.495.67zm2.22 1.737h.442C19.41 18 18.446 19 17.243 19c-1.205 0-2.169-.999-2.169-2.22 0-.39.146-.837.407-1.339.146-.28.325-.573.53-.873a13.24 13.24 0 0 1 .897-1.162l.335-.379.335.38a13.238 13.238 0 0 1 .895 1.161c.205.3.384.593.53.873.26.502.406.948.406 1.34h-.442z" />
                  <!-- <path
                          fill="#FF4F72"
                          d="M18.848 8.485a3.636 3.636 0 1 1 0-7.273 3.636 3.636 0 0 1 0 7.273zm.03-6.06a.455.455 0 0 0-.454.454V5a.455.455 0 0 0 .91 0V2.879a.455.455 0 0 0-.455-.455zm-.03 4.666a.515.515 0 1 0 0-1.03.515.515 0 0 0 0 1.03z"
                        /> -->
                </g>
              </svg>
              <svg class="alert" viewBox="0 0 24 24">
                <path fill="#FF4F72"
                  d="M13 11H11V5H13M13 15H11V13H13M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" />
              </svg>
            </div>
            <div v-if="currentCar.details.diagnostics.airbag" class="icon airbag">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g fill="none" fill-rule="evenodd">
                  <path fill="var(--grey)"
                    d="M17.29 10.413c.454.454.599 1.166.304 1.775l-2.229 4.629-1.865-3.208.097-.202 1.235-2.571a1.55 1.55 0 0 1 .415-.524 2.631 2.631 0 0 1-1.474-2.369 2.622 2.622 0 0 1 2.614-2.63A2.622 2.622 0 0 1 19 7.942a2.63 2.63 0 0 1-1.71 2.47zm.783-2.47c0-.926-.753-1.681-1.686-1.681-.934 0-1.687.755-1.687 1.681 0 .927.753 1.681 1.687 1.681.933 0 1.686-.754 1.686-1.68zm-6.245.184a3.178 3.178 0 1 0-6.357.002 3.178 3.178 0 0 0 6.357-.002zm.927 0c0 2.281-1.84 4.127-4.105 4.127-2.265 0-4.105-1.846-4.105-4.127C4.545 5.847 6.385 4 8.65 4c2.264 0 4.105 1.846 4.105 4.127zm-.3 6.682a.481.481 0 0 1 .167-.65.458.458 0 0 1 .634.171l3.185 5.588a.481.481 0 0 1-.166.65.458.458 0 0 1-.634-.171l-3.185-5.588zm4.411-2.989a.718.718 0 0 0-.34-.952.73.73 0 0 0-.967.337l-1.137 2.366.876 1.507 1.568-3.258zm-5.89 3.536l-1.488-1.062a.663.663 0 0 0-.919.134l-3.507 4.56a.667.667 0 0 0 .11.921c.13.094.277.141.427.141a.657.657 0 0 0 .525-.257l3.12-4.055.358.26 2.43 1.755a.616.616 0 0 0 .403.12l-1.458-2.517zm-4.118 5.017A1.57 1.57 0 0 1 5.6 21c-.34 0-.673-.108-.976-.325a1.637 1.637 0 0 1-.292-2.272l3.512-4.565a1.574 1.574 0 0 1 2.179-.32l1.567 1.118.133.147 1.981 3.417-.307.26a1.537 1.537 0 0 1-1.902.066l-2.067-1.493-2.569 3.34z" />
                  <!-- <path
                          fill="#FF4F72"
                          d="M18.848 8.485a3.636 3.636 0 1 1 0-7.273 3.636 3.636 0 0 1 0 7.273zm.03-6.06a.455.455 0 0 0-.454.454V5a.455.455 0 0 0 .91 0V2.879a.455.455 0 0 0-.455-.455zm-.03 4.666a.515.515 0 1 0 0-1.03.515.515 0 0 0 0 1.03z"
                        /> -->
                </g>
              </svg>
              <svg class="alert" viewBox="0 0 24 24">
                <path fill="#FF4F72"
                  d="M13 11H11V5H13M13 15H11V13H13M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" />
              </svg>
            </div>
            <div v-if="currentCar.details.diagnostics.battery" class="icon battery">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g fill="none" fill-rule="evenodd">
                  <path fill="var(--grey)"
                    d="M5.265 13.674v-.761h3.724v.76H5.265zm11.215 1.424v-1.425h-1.47v-.759h1.47v-1.425h.785v1.425h1.469v.76h-1.47v1.424h-.784zM15.18 6h4.361v1.587H22V19H2V7.587h2.459V6h4.36v1.587h6.362V6zm.932 1.588h2.498v-.685h-2.498v.685zm-10.722 0h2.498v-.685H5.39v.685zm-2.46 10.51h18.139V8.49H2.93v9.607z" />
                  <!-- <path
                          fill="#FF4F72"
                          d="M18.848 8.485a3.636 3.636 0 1 1 0-7.273 3.636 3.636 0 0 1 0 7.273zm.03-6.06a.455.455 0 0 0-.454.454V5a.455.455 0 0 0 .91 0V2.879a.455.455 0 0 0-.455-.455zm-.03 4.666a.515.515 0 1 0 0-1.03.515.515 0 0 0 0 1.03z"
                        /> -->
                </g>
              </svg>
              <svg class="alert" viewBox="0 0 24 24">
                <path fill="#FF4F72"
                  d="M13 11H11V5H13M13 15H11V13H13M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" />
              </svg>
            </div>
            <div v-if="currentCar.details.diagnostics.tire" class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g fill="none" fill-rule="evenodd">
                  <path fill="var(--grey)"
                    d="M5.535 18.684a6.01 6.01 0 0 1-.281.203c-.277.194-.385.278-.46.36l-.047.043a.31.31 0 0 0-.124.247v.176c0 .165.125.298.279.298h14.111c.153 0 .279-.133.279-.298v-.176c0-.036-.004-.075-.068-.197a.336.336 0 0 0-.128-.09l-.188-.119c-.465-.31-.685-.509-.752-.88a.86.86 0 0 1 .149-.65c1.15-1.674 1.735-3.429 1.735-5.214 0-4.631-3.607-8.398-8.04-8.398-4.433 0-8.04 3.767-8.04 8.398 0 1.85.564 3.603 1.631 5.071.145.2.228.533.194.777a.664.664 0 0 1-.25.45zm14.446.05c.101.112.163.222.192.35.05.136.08.293.08.453v.176c0 .71-.556 1.287-1.24 1.287H4.902c-.684 0-1.239-.577-1.239-1.287v-.176c0-.396.18-.782.468-1.005.122-.132.273-.247.584-.463l.08-.056A9.568 9.568 0 0 1 3 12.387C3 7.21 7.038 3 12 3s9 4.21 9 9.387c0 1.952-.62 3.875-1.841 5.718.029.025.068.055.12.092.041.032.075.054.147.1.039.026.069.046.092.065.18.084.34.212.463.372zm-9.163-9.83c-.023-.781-.03-.988-.028-1.027v-.013a1.004 1.004 0 0 0-.204.037c-1.636.444-2.203 1.517-2.416 1.92a1.26 1.26 0 0 1-.05.094c-.01.018-.016.032-.02.042.014.008.036.019.069.029l.947.279c.614.18 1.302.384 1.44.428.094-.095.196-.18.308-.254-.001-.095-.02-.708-.038-1.302l-.008-.233zm-2.841 1.669c-.233-.077-.392-.212-.46-.392-.07-.175-.045-.368.068-.57l.039-.075c.225-.426.906-1.717 2.802-2.232.218-.057.534-.116.768.072.102.08.221.239.21.527 0 .027.008.318.02.671l.016.544c.02.626.038 1.219.04 1.32 0 .332-.153.452-.244.494a1.313 1.313 0 0 0-.301.257.41.41 0 0 1-.324.136.728.728 0 0 1-.236-.043c-.112-.036-1.06-.315-1.686-.5l-.602-.176-.11-.033zm7.548-.909a.874.874 0 0 0-.096-.18c-.931-1.419-2.127-1.622-2.578-1.699l-.104-.02a.27.27 0 0 0-.047-.005.502.502 0 0 0-.006.075c0 .022.006.248.016.554l.01.337c.021.679.045 1.443.046 1.597.12.059.232.13.337.213.076-.024.46-.164.897-.322l.335-.12a107.834 107.834 0 0 1 1.19-.43zm-2.57-2.487c.472.08 1.91.326 2.988 1.967.124.188.277.472.173.753-.046.123-.16.285-.435.364-.033.01-.365.132-.743.27l-.393.141a144.7 144.7 0 0 1-1.248.45.76.76 0 0 1-.242.044.4.4 0 0 1-.301-.12 1.283 1.283 0 0 0-.34-.207c-.08-.031-.263-.148-.263-.503 0-.123-.032-1.143-.053-1.82l-.014-.52a11.883 11.883 0 0 1-.005-.161c0-.245.079-.44.228-.562.145-.12.331-.158.561-.113l.086.017zm-2.734 5.74a1.9 1.9 0 0 1-.145-.372c-.082-.027-.512-.15-.984-.289l-.259-.074a66.982 66.982 0 0 1-1.214-.356l-.017-.006a.957.957 0 0 0-.026.204c-.084 1.696.762 2.565 1.08 2.891l.075.08a.352.352 0 0 0 .031.03.276.276 0 0 0 .052-.058l.566-.827c.359-.524.756-1.105.84-1.223zm.504.352c-.065.091-.548.799-.924 1.346l-.398.583c-.065.093-.091.133-.096.14-.14.192-.32.303-.51.313H8.79a.667.667 0 0 1-.513-.24l-.06-.062c-.335-.347-1.35-1.394-1.257-3.354.013-.227.056-.547.304-.711.109-.073.293-.136.565-.037.041.013.643.189 1.174.341.6.174 1.165.339 1.259.368.315.1.383.283.396.383.026.12.08.248.15.368.046.074.126.276-.083.562zm3.08-.953c-.02.13-.054.26-.1.386.06.078.433.56.795 1.025l.282.363c.374.48.473.607.493.638a.027.027 0 0 0 .007.011.782.782 0 0 0 .124-.126l.018-.023c1.062-1.323.887-2.523.823-2.975l-.016-.106a.307.307 0 0 0-.009-.046.36.36 0 0 0-.071.018l-.304.107-.24.087c-1.068.383-1.674.598-1.802.641zm1.99-1.364l.158-.058c.24-.075.447-.061.61.043.109.07.245.212.279.501l.012.085c.07.477.28 1.92-.949 3.453-.137.172-.35.397-.639.397-.153-.006-.343-.064-.503-.302a47.883 47.883 0 0 0-.416-.536l-.333-.429c-.383-.493-.745-.958-.803-1.037-.197-.267-.145-.455-.097-.543.049-.116.082-.25.092-.386.007-.085.059-.297.397-.407.09-.03.712-.251 1.797-.64l.394-.141zm-2.007 5.004a.425.425 0 0 0-.038-.063l-.336-.434c-.177-.232-1.051-1.363-1.182-1.54-.131.023-.264.03-.4.025-.043.061-.255.371-.5.734l-.229.338c-.56.826-.69 1.015-.711 1.045l-.01.013c.026.016.082.048.185.088 1.586.602 2.676.063 3.086-.138.038-.02.07-.035.096-.045l.04-.023zm.113-.877l.347.452c.142.196.193.4.145.588-.05.184-.18.325-.392.422l-.08.038a4.21 4.21 0 0 1-1.928.474c-.54 0-1.093-.106-1.643-.314-.212-.08-.5-.22-.582-.507-.034-.127-.039-.325.14-.553.024-.03.315-.463.601-.884l.084-.125c.351-.52.683-1.007.741-1.088.192-.267.381-.273.484-.256a1.2 1.2 0 0 0 .397-.032c.083-.02.3-.033.507.252.08.11.85 1.108 1.179 1.533zm-2.234-3.09a.266.266 0 0 0 .531 0 .266.266 0 0 0-.53 0zm-.615 0a.881.881 0 1 1 0 0zm6.211.074c0-3.03-2.406-5.493-5.363-5.493-2.96 0-5.365 2.463-5.365 5.493 0 3.03 2.406 5.494 5.365 5.494 2.957 0 5.363-2.464 5.363-5.494zM11.9 5.903c3.316 0 6.013 2.764 6.013 6.16 0 3.395-2.697 6.158-6.013 6.158-3.318 0-6.015-2.763-6.015-6.158 0-3.396 2.697-6.16 6.015-6.16z" />
                  <!-- <path
                          fill="#FF4F72"
                          d="M18.848 8.485a3.636 3.636 0 1 1 0-7.273 3.636 3.636 0 0 1 0 7.273zm.03-6.06a.455.455 0 0 0-.454.454V5a.455.455 0 0 0 .91 0V2.879a.455.455 0 0 0-.455-.455zm-.03 4.666a.515.515 0 1 0 0-1.03.515.515 0 0 0 0 1.03z"
                        /> -->
                </g>
              </svg>
              <svg class="alert" viewBox="0 0 24 24">
                <path fill="#FF4F72"
                  d="M13 11H11V5H13M13 15H11V13H13M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" />
              </svg>
            </div>
            <div v-if="currentCar.details.diagnostics.brakes" class="icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                <g fill="none" fill-rule="evenodd">
                  <path fill="var(--grey)"
                    d="M19.127 11.993c0-3.96-3.189-7.17-7.127-7.17-3.938 0-7.127 3.21-7.127 7.17 0 3.959 3.19 7.17 7.127 7.17 3.938 0 7.127-3.211 7.127-7.17zm.759 0c0 4.39-3.532 7.947-7.886 7.947s-7.886-3.557-7.886-7.947c0-4.39 3.531-7.946 7.886-7.946s7.886 3.555 7.886 7.946zm-2.448-7.108L18.091 4A10.069 10.069 0 0 1 22 12c0 3.168-1.46 6.094-3.907 8l-.657-.882a8.996 8.996 0 0 0 3.48-7.117 8.952 8.952 0 0 0-3.478-7.116zM6.564 19.118L5.907 20A10.113 10.113 0 0 1 2 12c0-3.182 1.46-6.11 3.909-8l.653.885A8.952 8.952 0 0 0 3.084 12a8.996 8.996 0 0 0 3.48 7.117zm10.161-7.002c.045.105.07.229.07.374v.009c0 .165-.03.31-.09.437a.87.87 0 0 1-.247.322 1.101 1.101 0 0 1-.378.198c-.146.045-.31.07-.487.07-.25 0-.495-.044-.737-.13-.24-.088-.46-.221-.657-.4l.427-.515c.15.122.305.22.463.293.157.071.33.107.518.107.15 0 .267-.027.35-.081a.262.262 0 0 0 .123-.23v-.01a.328.328 0 0 0-.024-.125.257.257 0 0 0-.1-.1 1.121 1.121 0 0 0-.202-.095 3.366 3.366 0 0 0-.336-.1 4.16 4.16 0 0 1-.452-.137 1.229 1.229 0 0 1-.343-.186.744.744 0 0 1-.219-.276.95.95 0 0 1-.08-.412v-.009a.98.98 0 0 1 .086-.41.92.92 0 0 1 .234-.312c.103-.09.223-.156.362-.203.141-.048.296-.07.464-.07.242 0 .464.035.664.106.202.073.387.177.558.312l-.375.549a2.446 2.446 0 0 0-.434-.24 1.105 1.105 0 0 0-.422-.087c-.141 0-.246.029-.317.083a.252.252 0 0 0-.105.206v.009c0 .054.01.101.03.14.021.04.059.075.111.106.053.032.127.06.22.09.093.028.208.061.35.1.166.043.315.093.444.147.13.056.24.123.329.198.09.079.157.17.202.272zm-3.62.365v-.01c0-.11-.04-.197-.125-.262-.085-.064-.221-.097-.409-.097h-.835v.729h.86c.158 0 .283-.03.375-.09.091-.057.135-.148.135-.27zm-1.369-1.674v.7h.666a.74.74 0 0 0 .38-.083c.095-.054.142-.143.142-.266v-.01a.298.298 0 0 0-.122-.253.612.612 0 0 0-.352-.088h-.714zm1.472.94c.189.073.339.173.447.297.11.124.164.296.164.517v.009a.875.875 0 0 1-.086.398.783.783 0 0 1-.248.282 1.156 1.156 0 0 1-.39.171 2.075 2.075 0 0 1-.503.056h-1.56v-3.308h1.523c.378 0 .663.099.857.294.15.15.224.338.224.562v.01a.795.795 0 0 1-.128.447.736.736 0 0 1-.135.154.935.935 0 0 1-.165.112zm-4.869.347h.874l-.437-1.073-.437 1.073zm.113-1.947h.668l1.406 3.33H9.77l-.299-.74H8.082l-.3.74h-.737l1.407-3.33z" />
                  <!-- <path
                          fill="#FF4F72"
                          d="M18.848 8.485a3.636 3.636 0 1 1 0-7.273 3.636 3.636 0 0 1 0 7.273zm.03-6.06a.455.455 0 0 0-.454.454V5a.455.455 0 0 0 .91 0V2.879a.455.455 0 0 0-.455-.455zm-.03 4.666a.515.515 0 1 0 0-1.03.515.515 0 0 0 0 1.03z"
                        /> -->
                </g>
              </svg>
              <svg class="alert" viewBox="0 0 24 24">
                <path fill="#FF4F72"
                  d="M13 11H11V5H13M13 15H11V13H13M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" />
              </svg>
            </div>
            <div v-if="currentCar.details.diagnostics.security">
              <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <g fill="none" fill-rule="evenodd">
                    <path fill="var(--grey)"
                      d="M18.667 12H17.58a.833.833 0 0 1-.773-.533L15.473 8H7.2l-1.333 3.473a.833.833 0 0 1-.774.527H4v1h1.073l-.906 1.28V21h3.666v-2.667h7V21H18.5v-6.72L17.593 13h1.074v-1zM7.88 9h6.907l1.086 2.833c.022.063.048.123.08.18h-9.24c.031-.058.058-.118.08-.18L7.88 9zM6.833 20H5.167v-1.873c.257.133.543.204.833.206h.833V20zm9 0v-1.667h.834c.29-.002.575-.073.833-.206V20h-1.667zm.834-2.667H6a.833.833 0 0 1-.833-.833v-1.9l.88-1.247A.847.847 0 0 1 6.713 13h9.227a.847.847 0 0 1 .667.353l.88 1.247v1.9a.833.833 0 0 1-.82.833zM6 14.667h2.667v1H6v-1zm8 0h2.667v1H14v-1z" />
                    <path fill="var(--grey)"
                      d="M7.473 6.693a1.844 1.844 0 0 0-1.862 1.796l-.806.02.002-.048a2.65 2.65 0 0 1 2.672-2.583l-.006.815zM3.424 8.412c.077-2.21 1.92-3.976 4.11-3.934l-.016.815C5.767 5.26 4.29 6.67 4.228 8.44l-.806.02.002-.048zm-1.45-.003l.002-.048c.105-3.01 2.622-5.401 5.61-5.335l-.02.815C5.018 3.783 2.87 5.824 2.78 8.39l-.806.02z" />
                    <!-- <path
                            fill="#FF4F72"
                            d="M18.848 8.485a3.636 3.636 0 1 1 0-7.273 3.636 3.636 0 0 1 0 7.273zm.03-6.06a.455.455 0 0 0-.454.454V5a.455.455 0 0 0 .91 0V2.879a.455.455 0 0 0-.455-.455zm-.03 4.666a.515.515 0 1 0 0-1.03.515.515 0 0 0 0 1.03z"
                          /> -->
                  </g>
                </svg>
                <svg class="alert" viewBox="0 0 24 24">
                  <path fill="#FF4F72"
                    d="M13 11H11V5H13M13 15H11V13H13M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z" />
                </svg>
              </div>
            </div>
  
            <svg v-if="
              !currentCar.details.diagnostics.security &&
              !currentCar.details.diagnostics.brakes &&
              !currentCar.details.diagnostics.tire &&
              !currentCar.details.diagnostics.airbag &&
              !currentCar.details.diagnostics.battery &&
              !currentCar.details.diagnostics.oil
            " width="56px" height="56px" viewBox="-3 -2 60 60" version="1.1" xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Page-1" stroke="none" stroke-width="1.5" fill="none" fill-rule="evenodd">
                <g id="Artboard" transform="translate(-81.000000, -465.000000)" stroke="#c6c6ca">
                  <g id="icon_checkmark" transform="translate(81.000000, 465.000000)">
                    <circle id="Oval" cx="28" cy="28" r="28" fill="transparent"></circle>
                    <g id="Icons/Check" transform="translate(8.000000, 8.000000)" stroke="none" fill="var(--green)">
                      <path
                        d="M34.6392762,10.3816782 C35.1188378,10.8782787 35.105025,11.6696144 34.6084245,12.1491759 L16.5081772,29.6514571 C16.0542751,30.0897853 15.3541423,30.1159337 14.8709086,29.7379862 C14.8639187,29.7320227 14.8566015,29.7262734 14.8493141,29.7203964 C14.8345721,29.7086436 14.8200425,29.6961908 14.8057407,29.6833516 C14.7890566,29.6685225 14.7722678,29.6526626 14.7556705,29.6360654 L5.36611652,20.1788367 C4.87796116,19.6906813 4.87796116,18.8992251 5.36611652,18.4110698 C5.85427189,17.9229144 6.64572811,17.9229144 7.13388348,18.4110698 L15.662,26.991 L32.8717785,10.3508264 C33.368379,9.87126491 34.1597147,9.88507773 34.6392762,10.3816782 Z"
                        id="Combined-Shape"></path>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <p>
            {{ $t("message.diagnostics") }}
            <!-- {{
              this.$store.state.inDealerMode
                ? $t("message.health")
                : $t("message.diagnostics")
            }} -->
          </p>
        </div>
        <OdometerGauge style="align-self: end" :value="
          currentCar.details.odometer || currentCar['Odometer (mi)']
        " small />
      </div>
      <div class="link-grid">
        <svg @click="goToVehicleDetailPage" :class="{ noclick: !canClickVehicle }" id="gfs:icon/i-vehicle" viewBox="0 0 24 24">
          <path
            d="M21.167 8.875h-1.359a1.042 1.042 0 0 1-.966-.667l-1.667-4.333H6.833L5.167 8.217c-.157.396-.54.657-.967.658H2.833v1.25h1.342l-1.133 1.6v8.4h4.583v-3.333h8.75v3.333h4.583v-8.4l-1.133-1.6h1.342v-1.25zM7.683 5.125h8.634l1.358 3.542c.027.077.06.153.1.225H6.225c.039-.073.072-.148.1-.225l1.358-3.542zm-1.308 13.75H4.292v-2.342c.322.167.679.255 1.041.259h1.042v2.083zm11.25 0v-2.083h1.042c.362-.004.72-.092 1.041-.259v2.342h-2.083zm1.042-3.333H5.333A1.042 1.042 0 0 1 4.292 14.5v-2.375l1.1-1.558c.193-.27.501-.434.833-.442h11.533c.332.008.64.172.834.442l1.1 1.558V14.5c0 .569-.457 1.033-1.025 1.042zM5.333 12.208h3.334v1.25H5.333v-1.25zm10 0h3.334v1.25h-3.334v-1.25z" />
        </svg>
        <span @click="goToVehicleDetailPage" :class="{ noclick: !canClickVehicle }">
          {{ currentCar['Model Year']}} {{ currentCar['Model Name']}}
        </span>
        <svg v-if="!$store.state.inDealerMode" class="grey" id="gfs:icon/i-manage-fleet" viewBox="0 0 24 24">
          <path
            d="M21.4 8.042a1.042 1.042 0 0 1-.95-.609l-1.667-3.558h-8.591L8.525 7.433c-.17.372-.541.61-.95.609H5.158l-1.625 4.241c-.129.418-.497.718-.933.759H2v1.25h.6c.149-.003.297-.022.442-.059v6.934h1.25v-2.134c.322.167.679.255 1.041.259h8.334c.362-.004.72-.092 1.041-.259v2.134h1.25v-6.934c.145.037.293.056.442.059h2.267c.362-.004.72-.092 1.041-.259v2.134h1.25V9.242c.145.033.293.05.442.05h.6v-1.25h-.6zM9.683 7.958l1.309-2.833h7.016l1.309 2.833.05.084H9.633l.05-.084zM6.017 9.292h6.966l1.317 3.441c.042.107.092.21.15.309h-9.9c.058-.099.108-.202.15-.309l1.317-3.441zm7.65 8.75H5.333A1.042 1.042 0 0 1 4.292 17v-2.708h10.416V17c0 .575-.466 1.042-1.041 1.042zm5-5H16.4a1.083 1.083 0 0 1-.933-.759l-1.15-2.991h5.391V12c0 .575-.466 1.042-1.041 1.042zM17 10.542h1.667v1.25H17v-1.25zm-5 5h1.667v1.25H12v-1.25zm-6.667 0H7v1.25H5.333v-1.25z" />
        </svg>
        <span v-if="!$store.state.inDealerMode" class="grey">{{ currentCar['Fleet'] }}</span>
        <svg v-if="$store.state.inDealerMode" id="gfs:icon1/info-filled" viewBox="0 0 24 24" class="i-btn noclick">
          <path data-v-468a34f3=""
            d="M12 2c5.519 0 10 4.481 10 10s-4.481 10-10 10S2 17.519 2 12 6.481 2 12 2zm.83 8.33h-1.66v7h1.66v-7zM12.84 7h-1.68l.01 1.7h1.67V7z">
          </path>
        </svg>
        <span v-if="$store.state.inDealerMode" class="grey">{{ $t('message.condition') }}: {{ $t('message.new') }}</span>
        <svg v-if="driver" @click="goToDriverDetailPage" :class="{ noclick: $store.state.inDealerMode }" id="gfs:icon/i-driver" viewBox="0 0 24 24">
          <path
            d="M18.948 14.154c-.78-1.562-2.286-2.529-3.918-2.515h-1.186c1.44-.762 2.357-2.352 2.362-4.097v-.964C16.206 4.05 14.325 2 12.004 2c-2.32 0-4.201 2.05-4.201 4.578v.964c.005 1.745.921 3.335 2.362 4.097H8.979c-1.59-.016-3.067.9-3.865 2.4L2 20.458l2.716 1.118c.026-.508.098-1.011.212-1.504l-1.053-.385 2.327-4.82.062-.115c.555-1.06 1.595-1.707 2.715-1.687h6.05c1.144-.022 2.205.65 2.752 1.745l2.353 4.819-1.053.443c.11.48.177.971.203 1.465L22 20.42l-3.052-6.265zM9.13 7.542v-.964c0-1.73 1.287-3.132 2.874-3.132 1.588 0 2.875 1.402 2.875 3.132v.964c0 1.73-1.287 3.133-2.875 3.133-1.587 0-2.874-1.403-2.874-3.133zM17.975 22h-1.327c0-2.795-2.079-5.06-4.644-5.06-2.564 0-4.644 2.265-4.644 5.06H6.034c0-3.593 2.673-6.506 5.97-6.506 3.298 0 5.971 2.913 5.971 6.506z" />
        </svg>
        <span v-if="driver" @click="goToDriverDetailPage" :class="{ noclick: $store.state.inDealerMode }">
          {{ driver['Name'] }}
        </span>
      </div>
    </div>
    <!-- </div> -->
  </div>
</template>

<script>
import FuelGauge from "@/components/demo/FuelGauge.vue";
import OdometerGauge from "@/components/demo/OdometerGauge.vue";
import TagsList from "@/components/demo/TagsList.vue";
import ModalView from "@/components/demo/ModalView.vue";
import RemoteCommands from "@/components/demo/RemoteCommands.vue";
import RemoteLearnMore from "@/components/demo/RemoteLearnMore.vue";
import PRNDL from "@/components/demo/PRNDL.vue";

export default {
  props: {
    dataset: Object,
    whichMap: String,
    sidebarVisible: Boolean,
  },
  data() {
    return {
      showRemoteModal: false,
      remoteLearnMore: false,
    };
  },
  components: {
    FuelGauge,
    OdometerGauge,
    TagsList,
    ModalView,
    RemoteCommands,
    RemoteLearnMore,
    PRNDL,
  },
  computed: {
    currentCar: {
      get() {
        return this.$store.state.currentCar;
      },
      set(data) {
        this.$store.commit("setCurrentCar", data);
      },
    },
    showCurrentCar: {
      get() {
        return this.$store.state.showCurrentCar;
      },
      set(data) {
        if (data) {
          this.$store.commit("turnOnCurrentCarVisibility");
        } else {
          this.$store.commit("turnOffCurrentCarVisibility");
        }
      },
    },
    currentCarIndex: {
      get() {
        return this.$store.state.currentCarIndex;
      },
      set(data) {
        this.$store.commit("setCurrentCarIndex", data);
      },
    },
    canClickVehicle() {
      if (!this.$store.state.inDealerMode) return true;
      if (typeof this.currentCar.id === 'number') return true;
      return false;
    },
    driver() {
      if (this.currentCarIndex !== -1) {
        for (const driver of this.dataset.drivers) {
          if (driver["Vehicle"] === this.currentCar["Vehicle Label"]) {
            return driver;
          }
        }
      }
      return null;
    },
    driverIndex() {
      if (this.driver) {
        return this.dataset.drivers.indexOf(this.driver);
      }
      return -1;
    },
  },
  methods: {
    goToVehicleDetailPage() {
      if (this.canClickVehicle) {
        this.$router.push({
          name: "vehicle-detail",
          params: { id: `${this.currentCar.id || this.currentCarIndex}` },
        });
      }
    },
    goToDriverDetailPage() {
      if (!this.$store.state.inDealerMode) {
        this.$router.push({
          name: "driver-detail",
          params: { id: `${this.driver.id || this.driverIndex}` },
        });
      }
    },
    hideRemoteModal() {
      this.showRemoteModal = false;
    },
  }
}
</script>

<style lang="scss" scoped>
//TODO: add to global styles at some point, also used in FilterModal.vue
// @mixin frosted-glass {
//   background-color: rgba(255, 255, 255, 0.85);
//   position: relative;

//   /* needed for bg-color to work in firefox */
//   @supports ((-webkit-backdrop-filter: blur(2em)) or (backdrop-filter: blur(2em))) {
//     & {
//       background-color: rgba(255, 255, 255, 0.6);
//       -webkit-backdrop-filter: blur(16px);
//       backdrop-filter: blur(16px);
//     }
//   }
// }

.car-details {
  width: 320px;
  height: calc(100% - 131px);
  // max-height: 605px;
  box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  margin-left: 32px;
  margin-top: 32px;
  padding: 16px 24px;
  animation: slideMapDetail 0.5s ease;
  touch-action: none;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  position: relative;
}

// .frosted-glass {
//   @include frosted-glass;
// }

.detail-head {
  justify-content: space-between;
  padding-bottom: 8px;
  width: 100%;
}

.detail-body {
  // height: calc(100% - 120px);
  // max-height: 538px;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  padding-right: 2px;
}

@keyframes slideMapDetail {
  0% {
    margin-left: -335px;
  }

  100% {
    margin-left: 24px;
  }
}

.car-title {
  color: var(--dark);
  font-size: 21px;
  font-weight: 700;
  margin-bottom: 16px;
}

.car-subtitle {
  color: var(--dark);
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 4px;
}

.car-last-seen {
  color: var(--dark-grey);
  font-size: 11px;
  margin-bottom: 6px;
}

.car-update-location {
  color: var(--dark);
  font-size: 12px;
  margin-top: 4px;
}

.img-wrap {
  position: relative;
  margin-bottom: 20px;
}

.jellybean {
  width: 100%;
  padding: 20px 0;
  background-color: var(--white);
  border: 1px solid var(--light-grey-2);
  margin-top: 12px;
}

.below-img {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 24px;
  margin-bottom: -40px;
}

.outer-circle-btn {
  width: 54px;
  height: 54px;
  border: 1px solid var(--light-grey-2);
  border-radius: 50%;
  background-color: var(--white);
  position: absolute;
  bottom: -18px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.inner-circle-btn {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background-color: var(--blue);
  display: flex;
  align-items: center;
  justify-content: center;
}

.inner-circle-btn img {
  width: 20px;
  height: 20px;
}

.off-screen {
  position: absolute;
  top: 800px;
  width: 100%;
  text-align: center;
}

.exit {
  width: 10px;
  height: 10px;
  padding: 8px;
  margin-top: 2px;
  margin-right: -8px;
  cursor: pointer;
}

.stats-grid {
  display: grid;
  grid-template-rows: 100px 1fr;
  grid-template-columns: 144px 144px;
  // grid-gap: 32px 0;
  margin-top: 64px;
  margin-bottom: 32px;
  margin-left: -3px;
  justify-content: space-around;
}

.diagnostics img {
  width: 48px;
  height: 48px;
  margin-bottom: 4px;
}

.diagnostics {
  font-size: 13px;
  color: var(--dark-grey);
  justify-content: space-between;

  p {
    margin: 0;
    padding: 0;
  }
}

.link-grid {
  display: grid;
  grid-template-rows: repeat(3, 15px);
  grid-template-columns: 13px auto;
  grid-gap: 8px 3px;
  font-size: 13px;
  color: var(--blue);
  align-items: center;
}

.link-grid span,
.link-grid svg {
  cursor: pointer;
}

.link-grid svg {
  fill: var(--blue);
  width: 100%;
  height: 100%;
}

.link-grid span.grey,
.link-grid svg.grey {
  color: var(--grey);
  fill: var(--grey);
  cursor: default;
}

.link-grid span.noclick,
.link-grid svg.noclick {
  cursor: default;
}

.flex-wrap {
  flex-wrap: wrap;
}

.icons {
  max-width: 100px;
  justify-content: space-between;
  margin-top: 20px;
}

.icons .icon {
  // background: #fff;
  border-radius: 50%;
  border: 1px solid var(--light-grey);
  width: 24px;
  height: 24px;
  max-height: 24px;
  max-width: 24px;
  padding: 5px;
  margin: 5px;
  position: relative;
}

.icons .icon svg {
  height: 24px;
  width: 24px;
}

.icons .icon .alert {
  position: absolute;
  width: 14px;
  top: -14px;
  right: -7px;
}

.icons div:last-child {
  flex-grow: 1;
}

.icons div:last-child .icon {
  margin: 0 auto;
}

.fuel-gauge {
  grid-column: 1 / 3;
  justify-self: center;
}

svg.i-btn {
  fill: var(--grey);
}
</style>